"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortVariablesAsc = void 0;
function sortVariablesAsc(vars) {
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'base'
    });
    // some variable lists are read-only, so copy array before sorting
    return [...vars].sort((a, b) => collator.compare(a.name, b.name));
}
exports.sortVariablesAsc = sortVariablesAsc;
